import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Plus, Trash2, ArrowLeft } from "lucide-react";
import Meta from "../../components/Meta";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CustomChecklist = () => {
  const [newChecklistName, setNewChecklistName] = useState("");
  const [newChecklistItems, setNewChecklistItems] = useState([""]);
  const navigate = useNavigate();

  const addCustomChecklist = () => {
    if (
      newChecklistName.trim() &&
      newChecklistItems.filter((item) => item.trim()).length > 0
    ) {
      const newChecklist = {
        id: `custom-${Date.now()}`,
        slug: `custom-${Date.now()}`,
        name: newChecklistName,
        category: "custom",
        items: newChecklistItems.filter((item) => item.trim()),
      };
      const encodedChecklist = btoa(JSON.stringify(newChecklist));
      const shareableUrl = `/checklists/shared#${encodedChecklist}`;
      toast.success(
        "Checklist created! Share this link: " +
          window.location.origin +
          shareableUrl,
        {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      navigate(shareableUrl);
    }
  };

  const addNewItem = () => {
    setNewChecklistItems((prev) => [...prev, ""]);
  };

  const updateItem = (index, value) => {
    setNewChecklistItems((prev) =>
      prev.map((item, i) => (i === index ? value : item))
    );
  };

  const removeItem = (index) => {
    setNewChecklistItems((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <>
      <Meta
        title="Create Custom Checklist - Govind Sinha & Co."
        description="Create your own custom checklist and share it with others."
        canonical="https://cagovindsinha.com/checklists/custom/new"
      />
      <div className="min-h-screen pt-16 bg-gradient-to-br from-blue-50 to-indigo-100">
        <Navbar />
        <div className="container px-4 py-8 mx-auto max-w-7xl">
          <div className="max-w-2xl mx-auto">
            <div className="flex items-center gap-4 mb-6">
              <Link
                to="/checklists"
                className="p-2 text-gray-600 rounded-full hover:text-blue-600 hover:bg-white"
              >
                <ArrowLeft className="w-5 h-5" />
              </Link>
              <h1 className="text-3xl font-bold text-gray-900">
                Create Custom Checklist
              </h1>
            </div>

            <div className="p-6 bg-white rounded-lg shadow-md">
              <div className="mb-6">
                <label className="block mb-2 text-sm font-medium text-gray-700">
                  Checklist Name
                </label>
                <input
                  type="text"
                  value={newChecklistName}
                  onChange={(e) => setNewChecklistName(e.target.value)}
                  placeholder="Enter checklist name..."
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div className="mb-6">
                <label className="block mb-2 text-sm font-medium text-gray-700">
                  Checklist Items
                </label>
                {newChecklistItems.map((item, index) => (
                  <div key={index} className="flex gap-2 mb-2">
                    <input
                      type="text"
                      value={item}
                      onChange={(e) => updateItem(index, e.target.value)}
                      placeholder="Enter item..."
                      className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                    {newChecklistItems.length > 1 && (
                      <button
                        onClick={() => removeItem(index)}
                        className="p-2 text-red-500 rounded-lg hover:text-red-700 hover:bg-red-50"
                      >
                        <Trash2 className="w-4 h-4" />
                      </button>
                    )}
                  </div>
                ))}
                <button
                  onClick={addNewItem}
                  className="flex items-center gap-2 px-4 py-2 text-blue-600 rounded-lg hover:text-blue-700 hover:bg-blue-50"
                >
                  <Plus className="w-4 h-4" />
                  Add Item
                </button>
              </div>

              <div className="flex gap-4">
                <button
                  onClick={() => {
                    addCustomChecklist();
                    window.scrollTo(0, 0);
                  }}
                  className="flex-1 px-6 py-3 text-white transition-colors bg-blue-600 rounded-lg hover:bg-blue-700"
                >
                  Create Checklist
                </button>
                <Link
                  to="/checklists"
                  // onClick={() => window.scrollTo(0, 0)}
                  className="px-6 py-3 text-gray-600 transition-colors border border-gray-300 rounded-lg hover:bg-gray-50"
                >
                  Cancel
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <ToastContainer />
    </>
  );
};

export default CustomChecklist;
